import {
  AfterViewInit, Component, ElementRef, EventEmitter, forwardRef, HostListener, Input, Optional, Output,
  ViewChild
} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/merge';
import 'rxjs/add/operator/pairwise';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/fromEvent';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {NbinputConfig, SystemAttachment} from "./nbinput.entity";
import {NbinputUploadService} from "./nbinput-upload";



@Component({
  selector: 'nbinput-sign',
  template: require('./nbinput-sign.component.html'),
  styles: [require('./nbinput-sign.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputSignComponent),
      multi: true
    }
  ]
})

export class NbinputSignComponent implements AfterViewInit, ControlValueAccessor {
  @Input()
  token: string;
  upload = '';
  download = '';

  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};

  writeValue(obj: SystemAttachment): void {
    // 获取服务器已有的签名作为背景
    this.setImageAsBackground(obj);
  }
  registerOnChange(fn: any): void {if (fn) this.onChangeCallback = fn;}
  registerOnTouched(fn: any): void {if (fn) this.onTouchedCallback = fn;}
  setDisabledState?(isDisabled: boolean): void {this.disabled = isDisabled;}
  setImageAsBackground(obj)　{
    this.bgImage = this.download ? this.download + obj.url : obj.url;
    if (!this.readonly) {
      let img = new Image();
      img.addEventListener('load', ()=>this.cx.drawImage(img, 0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.width * img.height / img.width), false);
      img.src = this.bgImage;
    }
  }

  public bgImage:string;

  @Input()
  set data(val){
    this.setImageAsBackground(val);
  }

  @ViewChild('canvas') public canvas: ElementRef;
  @ViewChild('back') public background: ElementRef;

  @HostListener('window:resize', ['$event.target'])
  onResize() {
    this.canvas.nativeElement.width = this.canvas.nativeElement.offsetWidth;
    this.canvas.nativeElement.height = this.canvas.nativeElement.offsetHeight;
    this.background.nativeElement.width = this.background.nativeElement.offsetWidth;
    this.background.nativeElement.height = this.background.nativeElement.offsetHeight;
    this.cx.lineWidth = 2;
    this.cx.lineCap = 'round';
    this.cx.strokeStyle = '#f00';
    this.initBackground(this.background.nativeElement.width, this.background.nativeElement.height);
  }

  public disabled;
  @Input()
  public readonly = false;

  public isDraw = false;
  public editable = false;
  switchEditable() {
    if (!this.readonly&&!this.disabled){
      if (this.editable && this.isDraw) {
        const dataURL = this.canvas.nativeElement.toDataURL("image/png");
        const blobBin = atob(dataURL.split(',')[1]);
        const array = [];
        for(let i = 0; i < blobBin.length; i++) {
          array.push(blobBin.charCodeAt(i));
        }
        const res = new Blob([new Uint8Array(array)], {type: 'image/png'});
        this.uploader.upload(this.uploader.blobToFile(res,"sign"+(new Date().getUTCMilliseconds())+".png"),this.upload)
          .subscribe(e=>{
            this.submit(e);
          });
      }
      this.editable = !this.editable;
    }
  }

  @Output()
  public onSubmit: EventEmitter<any> = new EventEmitter();
  submit(val:SystemAttachment) {
    this.onChangeCallback(val);
    this.onSubmit.emit(val);
  }

  private cx: CanvasRenderingContext2D;
  private bg: CanvasRenderingContext2D;

  public ngAfterViewInit() {
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    this.cx = canvasEl.getContext('2d');
    const bgEl: HTMLCanvasElement = this.background.nativeElement;
    this.bg = bgEl.getContext('2d');
    this.onResize();
    this.captureEvents(this.canvas.nativeElement);
  }

  private captureEvents(canvasEl: HTMLCanvasElement) {
    Observable
      .fromEvent(canvasEl, 'mousedown')
      .switchMap(() => Observable
        .fromEvent(canvasEl, 'mousemove')
        .takeUntil(Observable.fromEvent(canvasEl, 'mouseup')
          .merge(Observable.fromEvent(canvasEl, 'mouseout'))
        )
        .pairwise())
      .subscribe((res: [MouseEvent, MouseEvent]) => {
        if (!this.readonly&&!this.disabled&&this.editable) {
          const rect = canvasEl.getBoundingClientRect();
          const prevPos = {
            x: res[0].clientX - rect.left,
            y: res[0].clientY - rect.top
          };
          const currentPos = {
            x: res[1].clientX - rect.left,
            y: res[1].clientY - rect.top
          };
          this.drawOnCanvas(prevPos, currentPos);
        }
      });
  }
  private drawOnCanvas(
    prevPos: { x: number, y: number },
    currentPos: { x: number, y: number }
  ) {
    if (!this.cx) { return; }
    this.cx.beginPath();
    if (prevPos) {
      this.cx.moveTo(prevPos.x, prevPos.y);
      this.cx.lineTo(currentPos.x, currentPos.y);
      this.cx.stroke();
      this.isDraw = true;
    }
  }

  initBackground(w: number, h: number) {
    if (this.bgImage) {

    } else {
      this.bg.font = '64px serif';
      this.bg.textAlign = 'center';
      this.bg.textBaseline = 'middle';
      this.bg.strokeStyle = '#ddd';
      this.bg.strokeText('签名处', w/2,h/2);
    }
  }

  public clearCanvas() {
    this.cx.clearRect(0,0,this.canvas.nativeElement.width,this.canvas.nativeElement.height);
    this.isDraw = false;
    this.initBackground(this.canvas.nativeElement.width,this.canvas.nativeElement.height);
  }

  @Input()
  type;

  constructor(
    private uploader: NbinputUploadService,
    @Optional() private config: NbinputConfig,
  ) {
    this.upload = config.uploadAPI;
    this.download = config.downloadAPI;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/nbinput/nbinput-sign.component.ts